module.exports = __webpack_public_path__ + "static/FI-HANDY-MAN.f3c8dfcf.jpg";